import { render, staticRenderFns } from "./courseDjustment-content-item.vue?vue&type=template&id=0dded4fa&scoped=true"
import script from "./courseDjustment-content-item.vue?vue&type=script&lang=js"
export * from "./courseDjustment-content-item.vue?vue&type=script&lang=js"
import style0 from "./courseDjustment-content-item.vue?vue&type=style&index=0&id=0dded4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dded4fa",
  null
  
)

export default component.exports